var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function CardCreditCardIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 6H3V8H21V6ZM21 11H3V18H21V11ZM1 6.00213C1 4.89638 1.89655 4 3.00091 4H20.9991C22.1042 4 23 4.89451 23 6.00213V17.9979C23 19.1036 22.1035 20 20.9991 20H3.00091C1.89584 20 1 19.1055 1 17.9979V6.00213ZM15 14C15 13.4477 15.4434 13 15.9991 13H18.0009C18.5527 13 19 13.4439 19 14C19 14.5523 18.5566 15 18.0009 15H15.9991C15.4473 15 15 14.5561 15 14Z", fill: "" })));
}
export var CardCreditCardIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: CardCreditCardIconInner }, props))); };
//# sourceMappingURL=CardCreditCardIcon.js.map